import { CloseIcon, ReceiptIcon } from '@assets/icons/Icons'
import { Transition } from '@constants/TransitionModal.contants'
import { Button, Card, CardContent, Dialog, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Toolbar, Typography } from '@mui/material'
import React, { FC, useState } from 'react'
import { SupplyContextType, useSupplyContext } from '../context/Supply.context'
import { useParams } from 'react-router-dom'

interface IOwnProps {
    listWarehouse: any[]
}
const StockAllocation: FC<IOwnProps> = ({ listWarehouse }) => {
  const { id } = useParams()
  const { supplyCtx, saveSupplyCtx } = useSupplyContext() as SupplyContextType
  const [data, setData] = useState<{ loading: boolean, openModal: boolean, form: { from: number, to: number, quantity: number } }>({ loading: false, openModal: false, form: { from: 0, to: 0, quantity: 0 } })

  const bodegasConStock = supplyCtx.supply.inventory_warehouse.filter(item => item.quantity > 0).map(item => item.id_warehouse)

  const addStock = () => {
    setData({ ...data, loading: true })
    const newArrayStocks = supplyCtx.supply.inventory_warehouse.map((item: any) => {
      if (item.id_warehouse === data.form.from) {
        return { ...item, quantity: item.quantity - data.form.quantity }
      }
      if (item.id_warehouse === data.form.to) {
        return { ...item, quantity: item.quantity + data.form.quantity }
      }
      return item
    })
    if (!supplyCtx.supply.inventory_warehouse.some(item => item.id_warehouse === data.form.to)) {
      newArrayStocks.push({ id: 0, id_warehouse: data.form.to, id_supply: Number(id), quantity: data.form.quantity })
    }

    saveSupplyCtx({ ...supplyCtx, supply: { ...supplyCtx.supply, inventory_warehouse: newArrayStocks } })
    setData({ ...data, loading: false, openModal: false, form: { from: 0, to: 0, quantity: 0 } })
    console.log('🚀 ~ newArrayStocks ~ newArrayStocks:', newArrayStocks)
  }

  return (
    <div>
      <Button variant='contained' size='medium' color='warning' onClick={() => setData({ ...data, openModal: !data.openModal })}>Asignar Stock </Button>
      <Dialog
        open={data.openModal}
        TransitionComponent={Transition}
        aria-labelledby='responsive-dialog-title'
        maxWidth='lg'
        fullWidth
      >
        <DialogTitle id='responsive-dialog-title' component='div' className='bg-azul p-0 text-white'>
          <Toolbar>
            <Typography variant='h6' component='div' className='color-title'>
              <ReceiptIcon className='me-2' /><span>AGREGAR STOCK</span>
            </Typography>
            <IconButton
              aria-label='close'
              onClick={() => setData({ ...data, openModal: !data.openModal })}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: '#fff'
              }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </DialogTitle>
        <DialogContent dividers>
          <Card className='shadow-sm'>
            <CardContent>
              <div className='row gy-3'>
                <div className='col-12 col-md-6'>
                  <FormControl fullWidth className='mt-4'>
                    <InputLabel id='label-sl-desde'>
                      Desde
                    </InputLabel>
                    <Select
                      labelId='label-sl-desde'
                      label='Desde'
                      id='sl-desde'
                      value={String(data.form.from)}
                      onChange={(e) => { setData({ ...data, form: { ...data.form, from: Number(e.target.value), to: 0 } }) }}
                    >
                      <MenuItem value='0'>Seleccione Bodega con stock disponible</MenuItem>
                      {
                            listWarehouse.filter(item => bodegasConStock.includes(item.id)).map(e => {
                              return (<MenuItem value={e.id} key={e.id}>{e.name}</MenuItem>)
                            })
                        }
                    </Select>
                  </FormControl>
                </div>
                <div className='col-12 col-md-6'>
                  <FormControl fullWidth className='mt-4'>
                    <InputLabel id='label-sl-hacia'>
                      Hacia
                    </InputLabel>
                    <Select
                      labelId='label-sl-hacia'
                      label='Hacia'
                      id='sl-hacia'
                      value={String(data.form.to)}
                      onChange={(e) => { setData({ ...data, form: { ...data.form, to: Number(e.target.value) } }) }}
                    >
                      <MenuItem value='0'>Seleccione Bodega</MenuItem>
                      {
                            listWarehouse.filter(item => item.id !== data.form.from).map(e => {
                              return (<MenuItem value={e.id} key={e.id}>{e.name}</MenuItem>)
                            })
                        }
                    </Select>
                  </FormControl>
                </div>
                <div className='col-12 col-md-6'>
                  {data.form.from !== 0 ? <div className='rounded-pill bg-warning p-2'>{Number(supplyCtx.supply.inventory_warehouse.find(item => item.id_warehouse === data.form.from)?.quantity) - data.form.quantity} unidades</div> : null}
                </div>
                <div className='col-12 col-md-6'>
                  <TextField
                    id='outlined-basic'
                    type='number'
                    label='Cantidad'
                    fullWidth
                    variant='outlined'
                    value={data.form.quantity}
                    onChange={(e) => {
                      if (Number(e.target.value) <= Number(supplyCtx.supply.inventory_warehouse.find(item => item.id_warehouse === data.form.from)?.quantity) && Number(e.target.value) >= 0) {
                        setData({ ...data, form: { ...data.form, quantity: Number(e.target.value) } })
                      }
                    }}
                  />
                </div>
                <div className='col-12 text-end'>
                  <Button variant='contained' size='medium' color='primary' onClick={addStock} disabled={data.loading || data.form.to === 0 || data.form.to === 0 || data.form.quantity === 0}>Asignar</Button>
                </div>
              </div>

            </CardContent>
          </Card>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default StockAllocation
